module.exports = "https://cdn-web.ertelecom.ru/b2c-domru/frontend/_next/static/images/main-mobile-da228ad4f2d89ea57faf01e67d7d6c14.svg";